import { MediaFileInfo } from '@reshub/model';

export class MediaFileInfoDto extends MediaFileInfo {}
export class WriteableMediaFileInfoDto extends MediaFileInfoDto {
  writeUrl: string;
}
